module.exports = __webpack_public_path__ + "img/color_en.73b8a5c.jpg";